import { ArrowRightAlt, Call } from "@ellaandil/ui";
import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Link } from "@/components/ui/Link";
import type { LinkStoryblok } from "@/generated/sb/sb-types";
import { Link as NextLink } from "@/i18n/routing";
import { sbLink } from "@/lib/storyblok/link";

export const LinkBlok = ({
	blok,
	className,
	rightIcon = true,
	unstyled = false,
	light = false,
}: BlokProps<LinkStoryblok> & {
	className?: string;
	rightIcon?: boolean;
	unstyled?: boolean;
	light?: boolean;
}) => {
	const href = sbLink(blok.link)?.href;
	if (!href) return null;

	return (
		<BlokWrap editable={blok} asChild>
			<Link
				as={NextLink}
				href={href}
				className={className}
				rightIcon={rightIcon ? ArrowRightAlt : undefined}
				unstyled={false}
				light={light}
			>
				{blok.text}
			</Link>
		</BlokWrap>
	);
};
